import React from 'react';
import CostCalcTable from '../../chancemng/costcalc/CostCalcTable';
import { sumCostCalcs } from '../../chancemng/costcalc/costCalcShared';

// 확정된(읽기전용) 원가 산출 내역 표. chancemng과 동일한 CostCalcTable을 공유한다(옵션 B,
// 2026-10-27 owner 승인).
const CostCalcLockList = ({ costs }) => {
  if (!costs || costs.length === 0) {
    return null;
  }

  const rows = costs.map((cost, index) => ({
    key: cost.id ?? index,
    no: index + 1,
    isEtc: cost?.masterTyp !== 'N',
    productNm: cost.productNm,
    productDesc: cost.productDesc,
    qty: cost.expCnt,
    unit: cost.productUnit,
    sellPrice: cost.unitVal,
    sellAmount: cost.saleVal,
    buyPrice: cost.priceVal,
    buyAmount: cost.buyVal,
    partnerNm: cost.sellPartnerNm,
    profit: cost.saleProfit,
    profitRate: cost.salePct,
    missingPartner: !cost.sellPartnerNm,
    invalid: false,
  }));

  const totals = sumCostCalcs(costs);

  return <CostCalcTable rows={rows} totals={totals} editable={false} />;
};

export default CostCalcLockList;
